import * as React from "react";
import { inject, observer } from "mobx-react";
import FormInputField from "./FormInputField";
import FormRadioField from "./FormRadioField";
import { ApplicationStore } from "../../../stores/ApplicationStore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faHandPaper } from "@fortawesome/free-solid-svg-icons";
import { ValidationStore } from "../../../stores/ValidationStore";

export interface Fields {
    label: string;
    value: string;
    measure: string;
}

interface State {
    otherValue: string;
}

interface Props {
    applicationStore?: ApplicationStore;
    validationStore?: ValidationStore;
    label: string | React.ReactNode;
    formType: string;
    radioName: string;
    inputFieldName?: string;
    info?: string;
    ifYesQuestions: Array<Fields>;
    required?: boolean;
    isPercentage?: boolean;
}

@inject("applicationStore")
@inject("validationStore")
@observer
export default class YesNoWithIfYesQuestionsWidget extends React.Component<Props, State> {
    componentDidMount() {
        if (this.props.required) {
            const { formType, radioName, inputFieldName, label } = this.props;
            const labelToString = label!.toString().replace("<[^>]*>", "");
            this.props.validationStore!.offerValidationUpdate(formType, radioName, (store: ApplicationStore) => {
                let isValid = !!store.findGeneralFormValue(formType, radioName);
                if (!!inputFieldName && store.findGeneralFormValue(formType, radioName) === "yes") {
                    isValid = isValid && !!store.findGeneralFormValue(formType, inputFieldName);
                }
                return isValid;
            });
        }
    }

    handleValidation = () => {
        const { formType, radioName, ifYesQuestions } = this.props;
        const store = this.props.applicationStore!;
        let isValid = !!store.findGeneralFormValue(formType, radioName);

        if (store.findGeneralFormValue(formType, radioName) === "yes") {
            isValid = isValid && ifYesQuestions.filter(q => !!store.findGeneralFormValue(formType, q.value)).length === ifYesQuestions.length;
        }

        return isValid;
    };

    render() {
        const isValid = this.props.required ? this.handleValidation() : false;
        return (
            <div className="card shadow">
                <div className="card-header">
                    <div className={`d-flex ${isValid ? `text-success` : ``}`}>
                        <div>
                            {this.props.label}
                            {this.props.required ? <span className="text-danger"> * </span> : ""}
                        </div>
                        {/* <div className="ml-auto">{isValid && <FontAwesomeIcon icon={faCheck} className="mr-2" />}</div> */}
                        {this.props.required && (
                            <div className="ml-auto">
                                {isValid ? (
                                    <FontAwesomeIcon icon={faCheck} />
                                ) : (
                                    <>
                                        <small className="text-danger">Missing value. Please enter a value for this question.</small>
                                        <FontAwesomeIcon icon={faHandPaper} className="text-danger ml-2" />
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                <div className="card-body">
                    <form>
                        <div className="form-row col-12 col-lg-8 mx-auto">
                            <div className="col-2 mt-2">
                                <div className="form-check">
                                    <label>
                                        <FormRadioField fieldName={this.props.radioName} fieldValue="yes" formType={this.props.formType} />
                                        <div className="new-label">Yes</div>
                                    </label>
                                </div>
                            </div>
                            <div className="col-2 mt-2">
                                <div className="form-check">
                                    <label>
                                        <FormRadioField fieldName={this.props.radioName} fieldValue="no" formType={this.props.formType} />
                                        <div className="new-label">No</div>
                                    </label>
                                </div>
                            </div>
                        </div>
                        {this.props.applicationStore!.findGeneralFormValue(this.props.formType, this.props.radioName) === "yes" &&
                            this.props.ifYesQuestions.map(question => {
                                return (
                                    <div key={question.value}>
                                        <div className="form-row mt-4 ml-3">
                                            <div className="col-12 col-lg-8 mx-auto font-italic font-weight-bolder">If yes, {question.label}</div>
                                        </div>
                                        <div className="form-row mt-2 ml-3">
                                            <div className="col-12 col-lg-8 mx-auto">
                                                <div className="row">
                                                    <div className="col-8">
                                                        <FormInputField
                                                            formType={this.props.formType}
                                                            type="number"
                                                            fieldName={question.value}
                                                            isPercentage={this.props.isPercentage}
                                                        />
                                                    </div>
                                                    <div className="col-4">{question.measure}</div>
                                                </div>
                                                {this.props.info && (
                                                    <small id="emailHelp" className="form-text text-muted">
                                                        {this.props.info}
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                    </form>
                </div>
            </div>
        );
    }
}
